// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"77add59c","455":"75cf58cc","609":"4bce1587","977":"966aca80"}[chunkId] + ".chunk.js";
};